<template>
    <select class="selectbox" :style="selectStyle" v-model="value" :required="required"
            @input="$emit('input', $event.target.value)"
            @change="$emit('change', $event.target.value)">
        <option value="">{{placeholder}}</option>
        <option v-for="(item,index) in list" :key="index" :value="item.value">
            {{ item.name }}
        </option>
    </select>
</template>

<script>
import dictApi from './dictApi';

export default {
    name: "dictSelect",
    data() {
        return {
            list : [],
            // 当前控件存储当前值的
            //currentValue : ''
        };
    },
    props: {
        mainStyle : Object,
        // 上级组件给予的值
        value: {
            type: String,
        },
        module: {
            type: String,
            default: "ad"
        },
        placeholder: {
            type: String,
            default: "--请选择--"
        },
        selectStyle: {
            type: String,
            default: "width: 80px"
        },
        required : {
            type : Boolean,
            default : false
        }
    },
    mounted() {

        const me = this;
        dictApi.getByModule(this.module, (data) => {
            me.list = data;
        });
        this.currentValue = this.value;
    }
};
</script>

<style lang="scss" scoped>
.selectbox {
    height: 30px;
    line-height: 30px;
}
</style>
